import styled from 'styled-components';
import type React from 'react';

export const CardsGridStyled = styled.div<{ ref?: React.MutableRefObject<HTMLDivElement | undefined> }>`
  margin-bottom: 16px;
  width: 100%;
  container-name: cards-grid;
  container-type: inline-size;

  > div,
  > a {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
